import axiosInstance from "../AxiosInstance";

export const handleUpdateProfile = async (data) => await axiosInstance.put('/user/updateProfile', data);
export const usageInfo = async () => await axiosInstance.get('/user/getUsageInfo');